import { useStyletron, withStyle } from 'baseui'
import { useTranslation } from 'react-i18next'
import { StyledBodyCell } from 'baseui/table-grid'

const useModalExportLogsTable = ({ data }) => {
  const [css] = useStyletron()
  const { t } = useTranslation()

  const CenteredBodyCell = withStyle(StyledBodyCell, {
    display: 'flex',
    alignItems: 'center',
  })

  const dataEmpty = !data || data.length === 0

  const rows = dataEmpty
    ? []
    : Object.entries(data).map(([index, item]) => {
      const idx = Number(index)
      const striped = idx % 2 === 0
      return { index: idx, item, striped }
    })

  return {
    css,
    t,
    CenteredBodyCell,
    dataEmpty,
    rows,
  }
}

export default useModalExportLogsTable
